import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import en from 'locales/en.json'

void i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    resources: {
      en,
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
